import Button from './button';
import ButtonGroup from './button-group';
Button.Group = ButtonGroup;
export default Button;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/button/index.js
// module id = 74
// module chunks = 0